import React, { FC, useEffect, useRef, useState } from "react";
import { Modal, Radio } from "antd";
import { PlayCircleOutlined } from '@ant-design/icons';
import closeIcon from "../../../assets/icons/close.svg";
import "./contentForm.scss";
import { Formik, Form, Field } from "formik";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import InputField from "../../../shared/components/InputField";
import UploadLogo from "../../../shared/components/UploadLogo";
import { Skeleton } from "antd";
import UploadContent from "../../../shared/components/UploadContent";
import closeRedIcon from "../../../assets/icons/close-red-icon.svg";
import { serialize } from "serializr";
import { convertJSONToFormData } from "../../../shared/utils/converJsonToFormData";
import { ContentLibraryModel } from "../../../models/ContentLibraryModel/contentLibrary.model";
import ContentLibraryService from "../../../services/ContentLibraryService/contentLibrary.service";

interface ContentFormProps {
  loading: boolean,
  title: string;
  visible: boolean;
  setVisible: Function;
  data?: any;
  setCurrentContent: Function;
  refreshData: Function;
  currentPageNumber: number;
}

const ContentForm: FC<ContentFormProps> = (props) => {
  const { loading, title, visible, setVisible, data, refreshData, setCurrentContent } = props;
  const formRef = useRef<any>();

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>();
  const [sourceUrl, setSourceUrl] = useState<any>(null);
  const [s3Id, setS3Id] = useState<string>("");

  useEffect(() => {
    setInitialValues({
      displayPicture: null,
      contentType: data?.contentType || "video",
      title: data?.title || null,
      description: data?.description || null,
      contentLength: data?.contentLength || 0,
      contentUrl: data?.contentUrl || null,
      visibility: data?.visibility || "public"
      //relatedTags: data?.relatedTags
    });
    setS3Id(data?.s3Id || "");
  }, [data, visible]);

  useEffect(() => {
    if (visible && data?.s3AttachmentUrl?.length) {
      setSourceUrl(data?.s3AttachmentUrl);
    }
    else {
      setSourceUrl(null);
      setS3Id("");
    }
  }, [visible, data]);

  const handleClose = () => {
    setVisible(false);
    setCurrentContent("");
    formRef.current.resetForm(initialValues);
  };

  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    values.s3Id = s3Id;
    let contentData = serialize(ContentLibraryModel, values);
    if (values.displayPicture) contentData.thumbnail = values.displayPicture;
    let jsonData = { content_library: contentData };
    let contentFormData = convertJSONToFormData(jsonData);
    console.log(jsonData);
    if (!data) {
      ContentLibraryService.createContent(
        contentFormData,
        () => {
          refreshData();
          formRef.current.resetForm(initialValues);
          setVisible(false);
        },
        () => { },
        () => {
          setButtonLoading(false);
        }
      ).then();
    } else {
      ContentLibraryService.updateContent(
        data?.id,
        contentFormData,
        () => {
          refreshData();
          formRef.current.resetForm(initialValues);
          setVisible(false);
        },
        () => { },
        () => {
          setButtonLoading(false);
        }
      ).then();
    }
  };

  const handleUploadComplete = (response: any) => {
    setS3Id(response?.successful[0]?.s3Multipart?.key);
    setSourceUrl(response?.successful[0]?.uploadUrl);
  };

  if (!visible) {
    return null
  }


  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={handleClose}
      footer={null}
      className="board-form__modal content-form__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      {loading
        ? <div style={{ padding: 20 }}>
          <Skeleton.Image active ></Skeleton.Image>
          <br></br>
          <br></br>
          <Skeleton paragraph={{ rows: 5 }} active ></Skeleton>
          <Skeleton.Node active>
            <PlayCircleOutlined style={{ fontSize: 40, color: '#bfbfbf' }} />
          </Skeleton.Node>
          <br></br>
          <br></br>
          <Skeleton paragraph={{ rows: 3 }} active ></Skeleton>
        </div>
        : <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          innerRef={formRef}
        >
          {({ setFieldValue, values, resetForm }) => {
            return (
              <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className="content-form__thumbnail">
                  <Field name="displayPicture" as="file-upload">
                    <UploadLogo
                      logoUrl={
                        values?.displayPicture
                          ? values?.displayPicture
                          : data?.displayPictureUrl
                      }
                      setFile={setFieldValue}
                      uploadText="Upload thumbnail"
                    />
                  </Field>
                </div>

                <div className="board-form__header">
                  <div className="board-form__title">{title}</div>
                </div>

                  <div className="board-form__input content-form__radio-group">
                  <div className="board-form__label">Content Type</div>
                  <Field as="radio-group" name="contentType">
                    <Radio.Group
                      value={values?.contentType}
                      defaultValue="video"
                      onChange={(e) => {
                        setSourceUrl(
                          data?.contentType === e.target.value
                            ? data?.s3AttachmentUrl
                            : null
                        );
                        console.log(e.target);
                        setFieldValue("contentType", e.target.value);
                      }}
                    >
                      <Radio value="video">Video</Radio>
                      <Radio value="pdf">PDF</Radio>
                      <Radio value="external_link">External Link</Radio>
                    </Radio.Group>
                  </Field>
                </div>

                <div className="board-form__input content-form__radio-group">
                  <div className="board-form__label">Visibility</div>
                  <Field as="radio-group" name="visibility">
                    <Radio.Group
                      value={values?.visibility}
                      defaultValue="publicaly_visible"
                      onChange={(e) => {
                        setFieldValue("visibility", e.target.value);
                      }}
                    >
                      <Radio value="publicaly_visible">Public</Radio>
                      <Radio value="unlisted">Unlisted</Radio>
                    </Radio.Group>
                  </Field>
                </div>

                <div className="board-form__input">
                  <div className="board-form__label">Content Title</div>
                  <InputField
                    type="text"
                    name="title"
                    placeholder="Type content title"
                  />
                </div>

                <div className="board-form__input">
                  <div className="board-form__label">Description</div>
                  <InputField
                    type="textarea"
                    rows={4}
                    name="description"
                    placeholder="Type description"
                  />
                </div>
                {values?.contentType !== "external_link" ? (
                  <>
                    <div className="board-form__input">
                      <div className="board-form__label">
                        Upload {values?.contentType === "pdf" ? "PDF" : "Video"}
                      </div>
                      {sourceUrl ? (
                        <div className="content-form__viewer">
                          <img
                            src={closeRedIcon}
                            alt=""
                            className="content-form__remove"
                            onClick={() => {
                              setSourceUrl(null);
                              setS3Id("");
                            }}
                          />
                          {data?.contentType === "pdf" ? (
                            <iframe
                              src={sourceUrl}
                              width="100%"
                              height="300px"
                              title="pdf"
                            />
                          ) : (
                            <video
                              src={sourceUrl}
                              controls
                              className="content-form__video"
                            />
                          )}
                        </div>
                      ) : (
                        <UploadContent
                          handleUploadComplete={handleUploadComplete}
                          contentType={["application/pdf", "video/*"]}
                        />
                      )}
                    </div>

                    <div className="board-form__input">
                      {values?.contentType === "pdf" ? (
                        <>
                          <div className="board-form__label">Number of Pages</div>
                          <InputField
                            type="number"
                            name="contentLength"
                            placeholder="Type number of pages"
                          />
                        </>
                      ) : (
                        <>
                          <div className="board-form__label">Duration</div>
                          <InputField
                            type="number"
                            name="contentLength"
                            placeholder="Type number of mins"
                            suffix="mins"
                          />
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="board-form__input">
                      <div className="board-form__label">External Link</div>
                      <InputField
                        type="text"
                        name="contentUrl"
                        placeholder="Paste your URL here"
                      />
                    </div>
                  </>
                )}

                {/* <div className="board-form__input">
                <div className="board-form__label">Related Tag</div>
                <Field as="tree-select" name="relatedTags">
                  <TreeSelect
                    style={{ width: "100%" }}
                    value={values?.relatedTags}
                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    treeData={treeOptions}
                    placeholder="Search"
                    allowClear
                    showSearch
                    //  multiple
                    onChange={(value, label, extra) => {
                      console.log(value, label, extra.allCheckedNodes);
                      setFieldValue("relatedTags", value);
                    }}
                  />
                </Field>
              </div> */}

                <div className="board-form__action">
                  <div
                    className="board-form__button"
                    onClick={() => {
                      handleClose();
                      resetForm(initialValues);
                    }}
                  >
                    <ButtonComponent buttonContent="Cancel" type="text" />
                  </div>
                  <div className="board-form__button">
                    <ButtonComponent
                      buttonContent={data ? "Update" : "Create"}
                      type="primary"
                      htmlType="submit"
                      loading={buttonLoading}
                    />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      }
    </Modal>
  );
};

export default ContentForm;
